// ============================================================================
// SYSTELOS MONITOR - Header Component
// ============================================================================
// Header fixo com 70px altura, borda amarela 3px
// Logo usando imagem S.png
// ADAPTADO PARA: MONITOR Standalone
// ============================================================================

import { useAuth } from '@/contexts/AuthContext'

interface HeaderProps {
  onMenuClick: () => void
  pagina?: string
}

export function Header({ onMenuClick, pagina = 'Dashboard' }: HeaderProps) {
  const { usuario, logout } = useAuth()

  const getIniciais = (nome: string): string => {
    if (!nome) return 'U'
    const partes = nome.split(' ')
    if (partes.length >= 2) {
      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase()
    }
    return nome.substring(0, 2).toUpperCase()
  }

  const iniciais = getIniciais(usuario?.nome || '')
  const escritorioNome = usuario?.escritorio?.nome || ''

  const handleLogout = () => {
    if (confirm('Deseja realmente sair do sistema?')) {
      logout()
    }
  }

  return (
    <header
      className="fixed top-0 left-0 right-0 z-[500] h-[70px] flex items-center justify-between px-4 md:px-6"
      style={{
        background: 'linear-gradient(135deg, #0F1B3D 0%, #1a2d5a 100%)',
        borderBottom: '3px solid #FFB800'
      }}
    >
      {/* ====== LADO ESQUERDO ====== */}
      <div className="flex items-center gap-4">
        {/* Botão Menu Hamburger */}
        <button
          onClick={onMenuClick}
          className="w-10 h-10 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-all"
          aria-label="Abrir menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Logo SYSTELOS MONITOR */}
        <div className="flex items-center gap-3">
          <img
            src="/S.png"
            alt="SYSTELOS MONITOR"
            className="w-10 h-10 rounded-xl"
          />

          {/* Nome do Sistema */}
          <div className="hidden sm:block">
            <div
              className="text-white text-lg font-bold tracking-wide"
              style={{ fontFamily: 'Poppins, sans-serif', letterSpacing: '1px' }}
            >
              SYSTELOS MONITOR
            </div>
            <div className="text-white/60 text-xs">
              {pagina}
            </div>
          </div>
        </div>
      </div>

      {/* ====== LADO DIREITO ====== */}
      <div className="flex items-center gap-3 md:gap-4">
        {/* Botão Notificações */}
        <button
          className="relative w-10 h-10 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-all"
          aria-label="Notificações"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </button>

        {/* Info do Usuário */}
        <div className="hidden md:flex items-center gap-3">
          <div className="text-right">
            <div className="text-white font-medium text-sm leading-tight">
              {usuario?.nome?.split(' ')[0] || 'Usuário'}
            </div>
            {escritorioNome && (
              <div className="text-[#FFB800] text-xs font-semibold">
                {escritorioNome}
              </div>
            )}
          </div>
        </div>

        {/* Avatar */}
        {usuario?.avatar_url ? (
          <img
            src={usuario.avatar_url}
            alt={usuario.nome}
            className="w-10 h-10 rounded-full object-cover border-2 border-white/30"
          />
        ) : (
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold border-2 border-white/30"
            style={{ backgroundColor: '#FFB800', color: '#0F1B3D' }}
          >
            {iniciais}
          </div>
        )}

        {/* Botão Sair */}
        <button
          onClick={handleLogout}
          className="hidden sm:flex items-center gap-2 px-4 py-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-all text-sm font-medium"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span>Sair</span>
        </button>
      </div>
    </header>
  )
}

export default Header

